import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AdminSidebar from '../modules/admin/components/AdminSidebar';
import AdminHeader from '../modules/admin/components/AdminHeader';

const SIDEBAR_MINIMIZED_STORAGE_KEY = 'tema_admin_sidebar_minimized';

const AdminLayout = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarMinimized, setIsSidebarMinimized] = useState(() => {
    try {
      return localStorage.getItem(SIDEBAR_MINIMIZED_STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });
  const isFullWidthContent = pathname === '/admin/uniform-reports'
    || pathname.startsWith('/admin/uniform-reports/compare')
    || pathname.startsWith('/admin/uniform-reports/')
    || pathname === '/admin/missing-reports'
    || pathname === '/admin/uniforms'
    || pathname === '/admin/uniform-categories'
    || pathname === '/admin/users'
    || pathname === '/admin/dashboard';

  useEffect(() => {
    setIsSidebarOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (!isSidebarOpen) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isSidebarOpen]);

  useEffect(() => {
    try {
      localStorage.setItem(SIDEBAR_MINIMIZED_STORAGE_KEY, isSidebarMinimized ? '1' : '0');
    } catch {
      // ignore storage errors
    }
  }, [isSidebarMinimized]);

  return (
    <div className={`admin-layout${isSidebarOpen ? ' admin-layout--sidebar-open' : ''}${isSidebarMinimized ? ' admin-layout--sidebar-minimized' : ''}`}>
      <AdminSidebar
        isOpen={isSidebarOpen}
        isMinimized={isSidebarMinimized}
        onClose={() => setIsSidebarOpen(false)}
        onToggleMinimize={() => setIsSidebarMinimized((prev) => !prev)}
      />
      <div className="admin-layout__main">
        <AdminHeader
          user={user}
          isSidebarOpen={isSidebarOpen}
          onToggleSidebar={() => setIsSidebarOpen((prev) => !prev)}
        />
        <div className={`admin-layout__content${isFullWidthContent ? ' admin-layout__content--full' : ''}`}>
          <Outlet />
        </div>
      </div>
      <button
        type="button"
        className="admin-layout__backdrop"
        onClick={() => setIsSidebarOpen(false)}
        aria-label="Tutup menu"
      />
    </div>
  );
};

export default AdminLayout;
